import classNames from "classnames";
import { useQuery } from "hooks/useQuery";
import { useDrag } from "react-dnd";
import { Row } from "react-table-8.10.7";
import { useSelector } from "react-redux";
import { RootState } from "store/store";
import { Transactions as TransactionsType } from "types/Models/books";

type Props = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLTableRowElement>,
  HTMLTableRowElement
> & { row: Row<TransactionsType> };

export const TransactionDraggableRow = (props: Props) => {
  const query = useQuery();
  const selectedTransactionId = query.get("selected_transaction_id");
  const { sliderTransactions } = useSelector(
    (state: RootState) => state?.transactions
  );

  const { transaction } = props.row.original;

  const [{ isDragging }, drag] = useDrag(
    () => ({
      type: "transaction",
      item: { transaction: JSON.stringify(transaction) },
      collect: (monitor) => ({
        isDragging: monitor.isDragging(),
      }),
    }),
    [transaction.uuid]
  );

  const ref = (node: HTMLTableRowElement | null) => {
    if (
      selectedTransactionId &&
      node &&
      transaction.uuid === selectedTransactionId
    ) {
      node.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    } else {
      drag(node);
    }
  };

  return (
    <tr
      ref={ref}
      {...props}
      className={classNames(
        "hover:t-bg-surface-lighter-grey t-cursor-pointer t-border-neutral-0 t-border-b t-border-0 t-text-body-sm t-border-solid",
        {
          "t-bg-purple--1": props.row.getIsSelected(),
          "t-bg-surface-lighter-grey":
            sliderTransactions.find(
              ({ transactionId }) => transactionId === transaction?.uuid
            ) || isDragging,
          "animate-transaction-row": transaction.uuid === selectedTransactionId,
          [props.className || ""]: props.className,
        }
      )}
    />
  );
};
